import Component from "gia/Component";
import Marquee3k from "marquee3000";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;

    Marquee3k.init({
      selector: "js-marquee",
    });
  }

  unmount() {}
}
